module.exports = __webpack_public_path__ + "img/404_illustration.fa49564c.svg";